import React from 'react';

type Props = {
  page: number;
  pages: number;
  total: number;
  onPage: (page: number) => void;
};

export default function Pagination({ page, pages, total, onPage }: Props) {
  if (pages <= 1) return null;
  return (
    <div className="pagination">
      <span className="muted">
        Page {page} of {pages} ({total} total)
      </span>
      <div className="pagination-buttons">
        <button type="button" className="btn btn-sm" disabled={page <= 1} onClick={() => onPage(page - 1)}>
          Previous
        </button>
        <button
          type="button"
          className="btn btn-sm"
          disabled={page >= pages}
          onClick={() => onPage(page + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
}
